import RouteConstant from "@/constant/RouteConstant.js";
import { getHomeInfo, getToken, getUserInfo } from "@/redux/slices/user.js";
import { dispatch } from "@/redux/store.js";
import {
  Box,
  Stack
} from '@mui/material';
import { useEffect, useState } from "react";
// import { KeepAlive, KeepAliveScope, RouterTabs } from 'react-route-cache'
import { KeepAliveRouteOutlet } from "@hhhgamehhh/keepalive-for-react";

import { Outlet, useLocation, useNavigate, useOutlet } from "react-router-dom";
import Header from "@/components/Header/Header";
import useMobileDetect from "next-device-detection";
import { useSelector } from "react-redux";
import { isUserCompleteGuide } from "@/utils/userUtils";
import axiosInstance from "@/utils/axios";
import API from "@/constant/API";
import { RouteCacheExlude, RouteCacheInclude } from '@/constant/RouteCache.js'
import useToggle from "@/hook/useToggle";
import Modal3DS from "@/components/Modal3DS";
import WlErrorBoundary from '@/error-boundary.jsx';
import {ErrorBoundary} from '@sentry/react'

import useRiskCheck from '@/hook/useRiskCheck'
import {useTranslation} from "react-i18next";
import {useConfirm} from "material-ui-confirm";
// import {getUAInfo} from "@/utils/utils";
import { enqueueSnackbar } from "notistack"
function BaseLayout(props) {
  const {children} = props
  const detectMobile = useMobileDetect();
  const navigate = useNavigate()
  const location = useLocation()
  const [record3DS, setRecord3DS] = useState(null);

  const { user } = useSelector((state) => state.user);

  const { risk } = useRiskCheck()
  const confirm = useConfirm();
  const { t } = useTranslation()
  const {
    toggle: toggle3DS,
    onToggle: onToggle3DS,
    setToggle: setToggle3DS,
  } = useToggle();

  useEffect(() => {
    window.navigate = navigate;
    
    if (location.pathname == RouteConstant.LOGIN ||
      location.pathname == RouteConstant.SECURITY_2FA ||
      location.pathname == RouteConstant.FORGOT_PW) return;

    if (!getToken()) {
      navigate(RouteConstant.LOGIN);
    } else {
      dispatch(getUserInfo());
      dispatch(getHomeInfo());

      _check3DS();// 用于用户确认账单

      _addActiveEventListener();
    }

    return () => {
      _removeActiveEventListener();
    }
  }, []);

  const _addActiveEventListener = () => {
    document.addEventListener("visibilitychange", _onDomActive);
  }
  const _removeActiveEventListener = () => {
    document.removeEventListener("visibilitychange", _onDomActive);
  }

  const _onDomActive = () => {
    _check3DS();
  }

  const _check3DS = async () => {
    const res = await axiosInstance.post(API.CARD_3DS_CHECK);
    if (res) {
      setRecord3DS(res);
      setToggle3DS(true);
    }
  }

  useEffect(() => {
    if (user != null && !isUserCompleteGuide(user) && location.pathname == RouteConstant.MAIN) {
      navigate({
        pathname: RouteConstant.HOME,
        replace: true,
      });
    }
  }, [user]);



  useEffect(() => {
    if (!user) {
      return;
    }
    //风控状态异常提示
    if (risk?.isRisk >= 1) {
      enqueueSnackbar(risk?.detail || t("user_risk_exception"), { variant: 'error' })
      return
    }
  }, [user]);

  useEffect(() => {
    // 部分列表页面不需要滚动条归零

    // 页面跳转，滚动条初始化
    window.document.body.scrollTo(0, 0);
  }, [location]);

  // const showDefaultHeader = CUSTOMIZE_HEADER_PAGES.indexOf(location.pathname) === -1;
  const showDefaultHeader = location.pathname === RouteConstant.MAIN;

  const outlet = useOutlet();

  return (
    <>
      <Stack direction="row" sx={{
        alignItems: "stretch",
        height: '100vh'
      }}>
        {/* {!detectMobile.isMobile && <SideMenu/>} */}
        <Stack direction="column" sx={{width: '100%', flex: 1, height: '100%'}}>
          {showDefaultHeader && <Header></Header>}
          <Stack sx={{
            flex: 1,
            display: 'flex',
            justifyContent: 'flex-start',
            flexDirection: 'column',
            alignItems: 'flex-start',
            overflowX: 'hidden',
            paddingBottom: '16px',
            height: '100%'
          }} className="app-main-content content">
            <Stack sx={{width: '100%', flex: 1, height: '100%'}}>
              <ErrorBoundary fallback={<WlErrorBoundary />}>
                <KeepAliveRouteOutlet
                  include={[...RouteCacheInclude]}
                  // exclude={[...RouteCacheExlude]}
                />
              </ErrorBoundary>
            </Stack>
            {/*RouteCacheExlude*/}
            {/*{children || <Outlet />}*/}
          </Stack>
        </Stack>

        {record3DS && <Modal3DS open={toggle3DS} onClose={onToggle3DS} record={record3DS} />}
      </Stack>
    </>
  )
}

export default BaseLayout;
